// Features: M004-F0803
// Tests: T-M004-0456 (model), T-M004-0458 (panel), T-M004-0459 (Playwright mock lane)
// WebUI #267: the room device list over Core's opaque proxy (Core #544, Spec mycelium-room-device-list 1.0.1).
// POST /api/v1/rooms/:id/lists with {op, list_type, since?, incarnation?, cursor?, limit?}. No filter and no org (Core sets them).
// Core relays the provider's status and body unread, so errors reach the caller unchanged (the model classifies them).
// snapshot pages through next_cursor; changes does too. Every page is checked against the room_uuid echo (ROOMLIST-RULE-011).
import api from './api';
import { assertRoomUuid, RoomListError } from '../components/room-controls/roomDeviceListModel';

export const LIST_TYPE = 'mycelium.room_device';
export const MAX_PAGES = 50;

const listsPath = (roomId) => `/v1/rooms/${roomId}/lists`;

async function post(roomId, body) {
  const response = await api.post(listsPath(roomId), { list_type: LIST_TYPE, ...body });
  const envelope = response.data;
  // A 202 (link pending) or any body that is not a list result is Core's own answer, not a list page.
  if (response.status === 202 || !envelope || envelope.success !== true || !envelope.data || !Array.isArray(envelope.data.items)) {
    const failure = new RoomListError('pending');
    failure.response = response;
    throw failure;
  }
  return envelope.data;
}

async function walk(roomId, first, expectedRoomUuid) {
  const pages = [];
  let roomUuid = expectedRoomUuid;
  let body = first;
  for (let i = 0; i < MAX_PAGES; i += 1) {
    const page = await post(roomId, body); // eslint-disable-line no-await-in-loop
    roomUuid = assertRoomUuid(page, roomUuid);
    pages.push(page);
    if (page.snapshot_required || page.next_cursor === null || page.next_cursor === undefined) return { pages, roomUuid };
    body = { ...first, cursor: page.next_cursor };
  }
  throw new RoomListError('generic');
}

export const roomListsApi = {
  // -> { pages, roomUuid }
  snapshot: (roomId, { roomUuid, limit } = {}) => walk(roomId, { op: 'list.snapshot', ...(limit ? { limit } : {}) }, roomUuid),
  changes: (roomId, since, incarnation, { roomUuid, limit } = {}) => walk(
    roomId,
    { op: 'list.changes', since, incarnation, ...(limit ? { limit } : {}) },
    roomUuid,
  ),
};

export default roomListsApi;
